import React from 'react';
import {type JSX} from 'react';
import type {LayoutChangeEvent, StyleProp, ViewStyle} from 'react-native';
import {InputField} from '@lookiero/aurora';

import type {DateFormat} from '@helpers';

import {useDateMask} from './useDateMask';

type DateInputProps = {
  value?: string;
  onChange: (value: string) => void;
  onBlur?: (value: string) => void;
  onFocus?: () => void;
  onLayout?: (e: LayoutChangeEvent) => void;
  error?: boolean;
  hint?: string;
  label: string;
  placeholder?: string;
  format?: DateFormat;
  testID?: string;
  id?: string;
  style?: StyleProp<ViewStyle>;
};

const DateInput = ({
  value,
  onChange,
  onBlur,
  onFocus,
  onLayout,
  error,
  hint,
  label,
  placeholder,
  format,
  testID,
  id,
  style,
}: DateInputProps): JSX.Element => {
  const {displayValue, selection, handleChange, handleSelectionChange, handleBlur} = useDateMask({
    value,
    onChange,
    onBlur,
    format,
  });

  return (
    <InputField
      id={id}
      name={id || 'dateOfBirth'}
      testID={testID}
      style={style}
      label={label}
      placeholder={placeholder}
      value={displayValue}
      selection={selection}
      onChange={handleChange}
      onSelectionChange={handleSelectionChange}
      onBlur={handleBlur}
      onFocus={onFocus}
      onLayout={onLayout}
      keyboardType="number-pad"
      error={error}
      hint={hint}
    />
  );
};

export {DateInput};
export type {DateInputProps};
